module.exports = __webpack_public_path__ + "img/item_link_engraving.742c291.webp";